import { segmentEventPush } from '../GTMdatalayer';

export const gstComponentViewedCartSegment = (cartId = '', displayMessage = '') => {
  segmentEventPush({
    event: 'GST Component Viewed',
    page_name: 'Bag Screen',
    cart_id: cartId,
    display_message: displayMessage
  });
};

export const gstComponentClickSegment = (componentName = '') => {
  segmentEventPush({
    event: 'Bag CTA Clicked',
    page_name: 'Bag Screen',
    component_name: componentName // Use GST Invoice, change
  });
};

export const saveWithGSTHalfCardLoadSegment = () => {
  segmentEventPush({
    event: 'Screen Viewed',
    screen_name: 'Save With GST Halfcard'
  });
};

export const saveWithGSTHalfCardClickSegment = (cartId = '', componentName = '', payload = {}) => {
  const {
    billing_address_pincode = '',
    shipping_address_pincode = '',
    same_billing_shipping_address = ''
  } = payload;
  segmentEventPush({
    event: 'GST CTA Clicked',
    page_name: 'Save With GST Halfcard',
    cart_id: cartId,
    component_name: componentName, // T&C, Validate GST, Add and Use for future Orders, Change Address, Validate Address
    billing_address_pincode,
    shipping_address_pincode,
    same_billing_shipping_address
  });
};

export const saveWithGSTHalfCardErrorSegment = (errorMessage = '') => {
  segmentEventPush({
    event: 'Page Load Error',
    page_name: 'Save With GST Halfcard',
    error_description: errorMessage
  });
};

export const savedGSTLoadSegment = () => {
  segmentEventPush({
    event: 'Screen Viewed',
    screen_name: 'Saved GST Screen'
  });
};

export const savedGSTCTAClickSegment = (cartId = '', componentName = '') => {
  segmentEventPush({
    event: 'Saved GST CTA Clicked',
    page_name: 'Saved GST Screen',
    cart_id: cartId,
    component_name: componentName // Add New GST Details, Delete, Validate GST, Okay
  });
};

export const savedGSTErrorSegment = (errorMessage = '') => {
  segmentEventPush({
    event: 'Page Load Error',
    page_name: 'Saved GST Screen',
    error_description: errorMessage
  });
};

export const billingAddressCTAClickedSegment = (cartId = '', ctaType = '', billingAddressPincode = '') => {
  segmentEventPush({
    event: 'Billing Address CTA Clicked',
    page_name: 'GST Billing Screen',
    cart_id: cartId,
    cta_type: ctaType,
    gst_billing_address_pincode: billingAddressPincode
  });
};

export const addressSearchBarClickedSegment = (cartId = '', screenName = '') => {
  segmentEventPush({
    event: 'Address Search Bar Clicked',
    page_name: screenName,
    cart_id: cartId
  });
};

export const addressTypeSelectedSegment = (cartId = '', ctaType = '', shippingAddressType = '') => {
  segmentEventPush({
    event: 'Address Type Selected',
    page_name: 'GST Shipping Screen',
    screen_name: 'GST Shipping Screen',
    cart_id: cartId,
    cta_type: ctaType,
    gst_shipping_address_type: shippingAddressType
  });
};

export const shippingAddressCTAClickedSegment = (cartId = '', ctaType = '', shippingAddressPincode = '') => {
  const eventData = {
    event: 'Shipping Address CTA Clicked',
    page_name: 'GST Shipping Screen',
    screen_name: 'GST Shipping Screen',
    cart_id: cartId,
    cta_type: ctaType
  };
  // Only add pincode for 'confirm' or 'continue' action, not for 'previous'
  if ((ctaType === 'confirm' || ctaType === 'continue') && shippingAddressPincode) {
    eventData.gst_shipping_address_pincode = shippingAddressPincode;
  }
  segmentEventPush(eventData);
};

export const gstBillingScreenViewedSegment = (cartId = '') => {
  segmentEventPush({
    event: 'Screen Viewed',
    screen_name: 'GST Billing Screen',
    cart_id: cartId
  });
};

export const gstShippingScreenViewedSegment = (cartId = '') => {
  segmentEventPush({
    event: 'Screen Viewed',
    screen_name: 'GST Shipping Screen',
    cart_id: cartId
  });
};

export const gstDetailsScreenViewedSegment = (cartId = '') => {
  segmentEventPush({
    event: 'Screen Viewed',
    screen_name: 'GST Details Screen',
    cart_id: cartId
  });
};

export const gstDetailsScreenErrorSegment = (errorMessage = '') => {
  segmentEventPush({
    event: 'Page Load Error',
    page_name: 'GST Details Screen',
    error_description: errorMessage
  });
};

export const gstBillingScreenErrorSegment = (errorMessage = '') => {
  segmentEventPush({
    event: 'Page Load Error',
    page_name: 'GST Billing Screen',
    error_description: errorMessage
  });
};

export const gstShippingScreenErrorSegment = (errorMessage = '') => {
  segmentEventPush({
    event: 'Page Load Error',
    page_name: 'GST Shipping Screen',
    error_description: errorMessage
  });
};

export const gstDetailsScreenCtaClickedSegment = (
  cartId = '',
  componentName = '',
  screenName = 'GST Details Screen'
) => {
  segmentEventPush({
    event: 'GST CTA Clicked',
    page_name: screenName,
    screen_name: screenName,
    cart_id: cartId,
    component_name: componentName
  });
};

export const gstShippingGstinCtaClickedSegment = (cartId = '', componentName = '') => {
  segmentEventPush({
    event: 'GST CTA Clicked',
    page_name: 'GST Shipping Screen',
    screen_name: 'GST Shipping Screen',
    cart_id: cartId,
    component_name: componentName
  });
};

export {
  getGstAddressSegmentPropsFromCart,
  getGstSessionAddressPins,
  buildGstInfoSessionPayload,
  isShippingGstApplicableFromGstInfo
} from './gstAddressUtils';